import { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";

// Sperr-Seite: wird angezeigt, wenn ein gescannter Code zu einer gesperrten
// Charge gehoert. Zeigt einen kurzen Hinweis und leitet anschliessend
// automatisch auf die Hauptseite ("/") weiter. Zusaetzlich manueller Link.
const REDIRECT_SECONDS = 8;

const BatchLocked = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const message =
    location.state?.message ||
    "Dieser Code ist nicht mehr gültig. Die zugehörige Charge wurde gesperrt.";
  const [seconds, setSeconds] = useState(REDIRECT_SECONDS);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((prev) => (prev > 0 ? prev - 1 : 0));
    }, 1000);

    const timeout = setTimeout(() => {
      navigate("/", { replace: true });
    }, REDIRECT_SECONDS * 1000);

    return () => {
      clearInterval(interval);
      clearTimeout(timeout);
    };
  }, [navigate]);

  return (
    <div
      style={{
        maxWidth: "520px",
        margin: "60px auto",
        padding: "32px 24px",
        textAlign: "center",
        background: "#ffffff",
        borderRadius: "16px",
        boxShadow: "0 8px 30px rgba(0, 0, 0, 0.08)",
      }}
    >
      <div style={{ fontSize: "48px", lineHeight: 1, marginBottom: "12px" }} aria-hidden="true">
        🔒
      </div>
      <h2 style={{ color: "#dc3545", marginBottom: "12px" }}>Code gesperrt</h2>
      <p style={{ color: "#444", marginBottom: "20px" }}>{message}</p>
      <p style={{ color: "#888", fontSize: "14px" }}>
        Sie werden in {seconds} Sekunde{seconds === 1 ? "" : "n"} zur Startseite weitergeleitet.
      </p>
      <Link
        to="/"
        style={{
          display: "inline-block",
          marginTop: "12px",
          padding: "10px 20px",
          background: "#007AFF",
          color: "#fff",
          borderRadius: "8px",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Jetzt zur Startseite
      </Link>
    </div>
  );
};

export default BatchLocked;
